import { useParams, Link } from 'react-router-dom';
import { CheckCircle, XCircle } from 'lucide-react';

export default function VerifyEmail() {
  const { status } = useParams<{ status: string }>();
  const success = status === 'success';

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900 px-4">
      <div className="max-w-md w-full bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-10 text-center">
        {success ? (
          <>
            <CheckCircle className="w-16 h-16 text-emerald-500 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Compte activé !</h2>
            <p className="text-gray-600 dark:text-gray-400 mb-6">
              Votre compte est maintenant actif. Vous pouvez vous connecter.
            </p>
            <Link
              to="/signin"
              className="inline-block px-6 py-2.5 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 transition-colors"
            >
              Se connecter
            </Link>
          </>
        ) : (
          <>
            <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">Lien invalide</h2>
            <p className="text-gray-600 dark:text-gray-400 mb-6">
              Ce lien de vérification est invalide ou a déjà été utilisé.
            </p>
            <Link
              to="/signin"
              className="inline-block px-6 py-2.5 bg-indigo-600 text-white rounded-lg font-medium hover:bg-indigo-700 transition-colors"
            >
              Retour à la connexion
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
